import React, { Component } from 'react';
import Header from '../../components/main.header.component';
import StackGrid from "react-stack-grid";
import sizeMe from 'react-sizeme';
import Modal from '../Modal';

class Hawaii extends Component {
  constructor(){
    super();
    this.state = {
      isOpen: false,
      url: ''
    };
    this.openModal = this.openModal.bind(this);
    this.closeModal = this.closeModal.bind(this);
  }

  openModal (evt) {
    let url = evt.target.src;
    if(url){ // clicking the actual image opens the Modal, and not just Div padding
      this.setState({
        isOpen: true,
        url: url
      });
    }
  }

  closeModal (evt) {
    this.setState({
      isOpen: false,
      url: ''
    });
  }

  render() {
    const { width } = this.props.size;
    return (
      <div>
        <Header
          props={this.props}
        />
      <div className="Hawaii">
        <StackGrid
          columnWidth={width <= 900 ? '100%' : '50%'}
          monitorImagesLoaded={true}
          gutterWidth={20}
          gutterHeight={30}
        >
            <div onClick={this.openModal}>
              <img src="http://payload228.cargocollective.com/1/12/398889/6868220/Kauai054.jpg" id="hawaii-image" alt=""/>
            </div>
            <div onClick={this.openModal}>
              <img src="http://payload228.cargocollective.com/1/12/398889/6868220/Mars.jpg" id="hawaii-image" alt=""/>
            </div>
            <div onClick={this.openModal}>
              <img src="http://payload228.cargocollective.com/1/12/398889/6868220/02_o_987.jpg" id="hawaii-image" alt=""/>
            </div>

            <div onClick={this.openModal}>
              <img src="http://payload228.cargocollective.com/1/12/398889/6868220/01_o_1000.jpg" id="hawaii-image" alt=""/>
            </div>

            <div onClick={this.openModal}>
              <img src="http://payload228.cargocollective.com/1/12/398889/6868220/Kauai025.jpg" id="hawaii-image" alt=""/>
            </div>

            <div onClick={this.openModal}>
              <img src="http://payload228.cargocollective.com/1/12/398889/6868220/Kauai055.jpg" id="hawaii-image" alt=""/>
            </div>
        </StackGrid>
        <br />
        <StackGrid
          columnWidth={width <= 900 ? '100%' : '25%'}
          monitorImagesLoaded={true}
          gutterWidth={20}
          gutterHeight={50}
        >

            <div onClick={this.openModal}>
              <img src="http://payload228.cargocollective.com/1/12/398889/6868220/Kauai033resize.jpg" id="hawaii-image" alt=""/>
            </div>

            <div onClick={this.openModal}>
              <img src="http://payload228.cargocollective.com/1/12/398889/6868220/04_o_639.jpg" id="hawaii-image" alt=""/>
            </div>

            <div onClick={this.openModal}>
              <img src="http://payload228.cargocollective.com/1/12/398889/6868220/Kauai%20resize.jpg" id="hawaii-image" alt=""/>
            </div>

            <div onClick={this.openModal}>
              <img src="http://payload228.cargocollective.com/1/12/398889/6868220/Kauai043reize.jpg" id="hawaii-image" alt=""/>
            </div>
        </StackGrid>
      </div>
        <Modal
          show={this.state.isOpen}
          onClose={this.closeModal}
          className="Modal-Backdrop" >
            <img
              className="moto-image"
              src={this.state.url}
              alt="lol"
            />

        </Modal>
      </div>
    );
  }
}

export default sizeMe()(Hawaii);